import $ from 'jquery';
import mapLoader from './yandexmaps.js';

let $page = $('.contacts-page');
let $mapCanvas = $page.find('.contacts-page__map__canvas');

const initMap = function() {

    if(!$mapCanvas.length) {
        return;
    }

    let latlng = $mapCanvas.data('latlng');
    let zoom = $mapCanvas.data('zoom') || 15;

    if(!latlng) {
        return;
    }

    mapLoader(
        $mapCanvas.get(0),
        {
            center: latlng,
            zoom: zoom
        },
        function(_map)
        {
            const map = _map;

            const placemark = new ymaps.Placemark(latlng, {}, {
                iconLayout: 'default#image',
                //iconImageCliptRect: [[0, 0], [90, 90]],
                iconImageHref: '/img/map-pin.png',
                iconImageSize: [30, 30],
                iconImageOffset: [-15 ,-15]
            });

            map.geoObjects.add(placemark);
        }
    );
}


const init = function()
{
    if($page.length) {
        initMap();
    }
}

export default init;